import { useTitle } from "../../hooks/useTitle";

export const Help = () => {
  useTitle("Patients");
  return <>Help component</>;
};
